import type {SagaIterator} from 'redux-saga';
import {call, put, select} from 'typed-redux-saga';
import {Api, ApiError} from 'modules/utils/Api';

import {
	fetchContextualPromptSuccess,
	fetchContextualPromptError,
	declineContextualPromptSuccess,
	declineContextualPromptError,
	openContextualPrompt,
	closeContextualPrompt,
	type fetchContextualPrompt,
	type declineContextualPrompt
} from 'modules/actions/user';
import {getUserUID} from 'modules/selectors';
import {globalError} from 'modules/actions';
import {delay} from 'typed-redux-saga/macro';

export const fetchContextualPromptSaga = function* (
	_action: ReturnType<typeof fetchContextualPrompt>
): SagaIterator {
	try {
		const uid = yield* select(getUserUID);

		if( uid) {
			const response = yield* call(Api.User.checkContextualPrompt, {uid});

			ApiError.CHECK(response.data);

			yield* put(fetchContextualPromptSuccess(response.data.success.prompt));

			const prompts = [response.data.success.prompt].flatMap((it) => it);

			if( prompts.length ) {
				yield* put(openContextualPrompt());
				const CLOSE_DELAY = 10000;
				yield* delay(CLOSE_DELAY);
				yield* put(closeContextualPrompt());
			}
		}



	} catch (e) {
		const error = e as ApiError;
		yield* put(globalError(error));
		yield* put(fetchContextualPromptError());
		yield* put(closeContextualPrompt());
	}
};

export const declineContextualPromptSaga = function* ({
	payload,
}: ReturnType<typeof declineContextualPrompt>): SagaIterator {
	try {
		const response = yield* call(Api.User.declineContextualPrompt, payload);

		ApiError.CHECK(response.data);

		yield* put(declineContextualPromptSuccess(payload));
	} catch (e) {
		const error = e as ApiError;
		yield* put(globalError(error));
		yield* put(declineContextualPromptError());
	}
};
